import { render, staticRenderFns } from "./japanese-general.vue?vue&type=template&id=4981cc8e&scoped=true&"
import script from "./japanese-general.vue?vue&type=script&lang=js&"
export * from "./japanese-general.vue?vue&type=script&lang=js&"
import style0 from "./japanese-general.vue?vue&type=style&index=0&id=4981cc8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4981cc8e",
  null
  
)

export default component.exports